import { Divider, Stack } from '@mui/material'
import { Fragment } from 'react'
import { SkeletonText } from 'utoniq-ui'

import { Cell, CellFrame } from '@/core/architecture'

export const PreSaleContentSkeletonCell: Cell = ({}) => {
  return (
    <CellFrame sx={{ pt: 3, pb: 5 }}>
      <Stack sx={{ py: 2 }}>
        <SkeletonText variant="small" width="25%" />
      </Stack>
      <Stack direction="row" alignItems="center" spacing={4} sx={{ pb: 4 }}>
        {Array.from(Array(4).keys()).map(index => (
          <Fragment key={index}>
            <Stack flex={1} spacing={1}>
              <SkeletonText variant="small" />
              <SkeletonText variant="small" />
            </Stack>
            {3 > index && <Divider orientation="vertical" flexItem />}
          </Fragment>
        ))}
      </Stack>
      <SkeletonText variant="body2" />
      {Array.from(Array(4).keys()).map((info, index) => (
        <Stack sx={{ py: 2 }} key={index} spacing={1}>
          <SkeletonText variant="body2" />
          <SkeletonText variant="body2" />
        </Stack>
      ))}
    </CellFrame>
  )
}
